export default __webpack_public_path__ + "static/media/intro-bg.e8118893.png";